import "./Cards.css"
import CardTotalLicenciados from "./CardTotalLicencados";
import CardUsuariosAtivos from "./CardUsuariosAtivos";
import CardsPedidosSaques from "./CardPedidosSaques";

const CardsAdminUsuarios = (props) => {
    return(
      <section className="summary-grid">

        <CardTotalLicenciados total={props.total}/>
        
        <CardUsuariosAtivos ativos={props.ativos} inativos={props.inativos}/>

        <CardsPedidosSaques />

      </section>
    );
};

export default CardsAdminUsuarios;